<div id="hotel_map">
  <span id="btn-toc-map" (click)="toggleTocMap()">{{ viewTocMap === true ? '&laquo;' : '&raquo;' }}</span>
  <div id="layertree" [ngClass]="[ viewTocMap ? 'tocMostrar' : 'tocOcultar']">
    <h5>Capas</h5>
    <ul class="ul-left">
      <li><span>OSM layer</span>
        <fieldset id="layer0">
          <label class="checkbox" for="visible0">
            visible <input id="visible0" class="visible" type="checkbox" />
          </label>
          <label>
            opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
          </label>
        </fieldset>
      </li>
      <!-- GRUPO 10  -->
      <li> <i class="fa fa-folder-open-o mx-1" aria-hidden="true"></i>
        <span>Base</span>
        <fieldset id="layer1">
          <label class="checkbox" for="visible1">
            visibilidd <input id="visible1" class="visible" type="checkbox" />
          </label>
          <label>
            opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
          </label>
        </fieldset>

        <ul>
          <li>
            <span class="item-title">Borde</span>
            <fieldset id="layer10">
              <label class="checkbox" for="visible10">
                visible <input id="visible10" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Sectores</span>
            <fieldset id="layer11" class="fieldset-mod">
              <label class="checkbox" for="visible11">
                <span class="item-label">visible</span> <input id="visible11" class="visible" type="checkbox" />
              </label>
              <label>
                <span class="item-label">opacidad</span> <input class="opacity" type="range" min="0" max="1"
                  step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Inmuebles</span>
            <fieldset id="layer12">
              <label class="checkbox" for="visible12">
                <span class="item-label">visible</span> <input id="visible12" class="visible" type="checkbox" />
              </label>
              <label>
                <span class="item-label">opacidad</span> <input class="opacity" type="range" min="0" max="1"
                  step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Inm. Religiosos</span>
            <fieldset id="layer13">
              <label class="checkbox" for="visible13">
                <span class="item-label">visible</span> <input id="visible13" class="visible" type="checkbox" />
              </label>
              <label>
                <span class="item-label">opacidad</span> <input class="opacity" type="range" min="0" max="1"
                  step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Area No Catalogada</span>
            <fieldset id="layer14">
              <label class="checkbox" for="visible14">
                <span class="item-label">visible</span> <input id="visible14" class="visible" type="checkbox" />
              </label>
              <label>
                <span class="item-label">opacidad</span> <input class="opacity" type="range" min="0" max="1"
                  step="0.01" />
              </label>
            </fieldset>
          </li>
          
        </ul>
      </li>
      <!-- GRUPO 20  -->
      <li><i class="fa fa-folder-open-o mx-1" aria-hidden="true"></i>
        <span>Sector 01</span>
        <fieldset id="layer2">
          <label class="checkbox" for="visible2">
            visibilidd <input id="visible2" class="visible" type="checkbox" />
          </label>
          <label>
            opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
          </label>
        </fieldset>
        <ul>
          <li>
            <span class="item-title">Sótanos 1</span>
            <fieldset id="layer20">
              <label class="checkbox" for="visible20">
                visible <input id="visible20" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Sótanos 2</span>
            <fieldset id="layer21">
              <label class="checkbox" for="visible21">
                visible <input id="visible21" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 1º nivel</span>
            <fieldset id="layer22">
              <label class="checkbox" for="visible22">
                visible <input id="visible22" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 2º nivel</span>
            <fieldset id="layer23">
              <label class="checkbox" for="visible23">
                visible <input id="visible23" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 3º nivel</span>
            <fieldset id="layer24">
              <label class="checkbox" for="visible24">
                visible <input id="visible24" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 4º nivel</span>
            <fieldset id="layer25">
              <label class="checkbox" for="visible25">
                visible <input id="visible25" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 5º nivel</span>
            <fieldset id="layer26">
              <label class="checkbox" for="visible26">
                visible <input id="visible26" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
        </ul>
      </li>
      <!-- GRUPO 30  -->
      <li><i class="fa fa-folder-open-o mx-1" aria-hidden="true"></i>
        <span>Sector 02</span>
        <fieldset id="layer3">
          <label class="checkbox" for="visible3">
            visibilidd <input id="visible3" class="visible" type="checkbox" />
          </label>
          <label>
            opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
          </label>
        </fieldset>
        <ul>
          <li>
            <span class="item-title">Sótanos 1</span>
            <fieldset id="layer30">
              <label class="checkbox" for="visible30">
                visible <input id="visible30" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
        
          <li>
            <span class="item-title">Bloq. 1º nivel</span>
            <fieldset id="layer31">
              <label class="checkbox" for="visible31">
                visible <input id="visible22" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 2º nivel</span>
            <fieldset id="layer32">
              <label class="checkbox" for="visible32">
                visible <input id="visible32" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 3º nivel</span>
            <fieldset id="layer33">
              <label class="checkbox" for="visible33">
                visible <input id="visible33" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 4º nivel</span>
            <fieldset id="layer34">
              <label class="checkbox" for="visible34">
                visible <input id="visible34" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 5º nivel</span>
            <fieldset id="layer35">
              <label class="checkbox" for="visible35">
                visible <input id="visible35" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
        </ul>
      </li>
      <!-- GRUPO 40  -->
      <li><i class="fa fa-folder-open-o mx-1" aria-hidden="true"></i>
        <span>Sector 03</span>
        <fieldset id="layer4">
          <label class="checkbox" for="visible4">
            visibilidd <input id="visible4" class="visible" type="checkbox" />
          </label>
          <label>
            opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
          </label>
        </fieldset>
        <ul>
          <li>
            <span class="item-title">Sótanos 1</span>
            <fieldset id="layer40">
              <label class="checkbox" for="visible40">
                visible <input id="visible40" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
        
          <li>
            <span class="item-title">Bloq. 1º nivel</span>
            <fieldset id="layer41">
              <label class="checkbox" for="visible41">
                visible <input id="visible42" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 2º nivel</span>
            <fieldset id="layer42">
              <label class="checkbox" for="visible42">
                visible <input id="visible42" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 3º nivel</span>
            <fieldset id="layer43">
              <label class="checkbox" for="visible43">
                visible <input id="visible43" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 4º nivel</span>
            <fieldset id="layer44">
              <label class="checkbox" for="visible44">
                visible <input id="visible44" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Bloq. 5º nivel</span>
            <fieldset id="layer45">
              <label class="checkbox" for="visible45">
                visible <input id="visible45" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
        </ul>
      </li>
    </ul>

  </div>
</div>

<!--<div class="ol-popup">
  <a href="#" id="popup-closer" class="ol-popup-closer"></a>
  <div id="popup-content"></div>
</div>-->
<!-- convertir a Angular COMPONENT-->
<!--<div id="popup" class="ol-popup">{{ infoElemento | json}}</div>-->
<!-- -->
<div id="popup" class="ol-popup" >
  <a id="popup-closer" class="ol-popup-closer" ></a>
  <div *ngIf="infoElemento">
    <p class="item-line-pop-up"><img
        src="{{urlWebServer}}/registrofotografico/{{infoElemento.codregistr | slice : 0 : 10 }}/arquitectonica/F21.jpg"
        width=300></p>
    <p class="item-line-pop-up">Nro. Ficha: <b><a>{{infoElemento.codregistr}}</a></b> </p>
    <p class="item-line-pop-up">Reg. Foto: <b><a>{{infoElemento.cod_lote}}</a></b> </p>
    <p class="item-line-pop-up">Cat. Catalog.: <b><a>{{infoElemento.catcatalog}}</a></b> </p>
    <p class="item-line-pop-up">Zonific.: <b><a>{{infoElemento.catzonific}}</a></b> </p>
    <p class="item-line-pop-up">Reg. Foto: <b><a routerLink="kiki">{{infoElemento.cod_lote}}</a></b> </p>
    <button class="btn btn-primary btn-sm" (click)="cargarFicha(infoElemento.codregistr)">ver</button>
  </div>
</div>

<!---->
<div id="info">&nbsp;</div>
<!-- PRUEBA -->
<!--<div id="prueba" *ngIf="infoElemento">
  <li>{{ infoElemento.cod_catalo }}</li>
</div>-->
<div class="container" *ngIf="infoFichaCatalogacion" id="info_cat_ficha_inmaterial">
  <div class="row">
    <div class="col-md-12 text-center" >
      <h3 class="text-uppercase">Ficha de Registro de Catalogacion de Inmuebles de Acceso Publico</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 col-sm-6 align-content-end">
      <div class="alert alert-info font-weight-bolder">
        {{infoFichaCatalogacion.nroficha}}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 col-sm-12 text-center">
      <h4>Informacion de Registro Arquitectónico</h4>
    </div>
    
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="row">
        <div class="col-md-12 border bg-warning text-center font-weight-bolder">
          INFORMACION GENERAL
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 border border-top-0 bg-warning">
          DECLARADO PATRIMONIO
        </div>
        <div class="col-md-6 border border-top-0">
          <div>{{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].declarado_patrimonio}}</div>
          <div>{{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].resolucion_patrimonio}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 border border-top-0 bg-warning">
          DIRECCION
        </div>
        <div class="col-md-6 border border-top-0">
          {{infoFichaCatalogacion.direccion}}
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 border border-top-0 bg-warning">
          BARRIO
        </div>
        <div class="col-md-6 border border-top-0" >
          {{infoFichaCatalogacion.barrio}}
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 border border-top-0 bg-warning">
          DENOMINACION
        </div>
        <div class="col-md-6 border border-top-0" >
          {{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].denominacion}}
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 border border-top-0 bg-warning">
          CATEGORIA DE CATALOGACIÓN
        </div>
        <div class="col-md-6 border border-top-0" >
          <div class="badge badge-warning mx-1">{{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].ficha_catcatalogacion.abreviacion}}</div>
          <div class="badge badge-warning mx-1">{{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].ficha_catcatalogacion.nombre}}</div>
          
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 border border-top-0 bg-warning">
          ZONIFICACIÓN
        </div>
        <div class="col-md-6 border border-top-0" >
          <div class="badge badge-warning">{{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].categoria_zonificacion}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 border border-top-0 bg-warning">
          SECTOR DE PARAMETROS
        </div>
        <div class="col-md-6 border border-top-0" >
          <div class="badge badge-warning">{{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].ficha_sectorparametro.abreviacion}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 border border-top-0 bg-warning">
          SECTOR DE GESTION
        </div>
        <div class="col-md-6 border border-top-0" >
          <div class="badge badge-warning mx-1">{{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].globales_sectorgestion.abreviacion}}</div>
          <div class="badge badge-warning mx-1">{{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].globales_sectorgestion.descripcion}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 border border-top-0 bg-warning">
          FILIACION CULTURAL
        </div>
        <div class="col-md-6 border border-top-0">
          <div class="item_list_1" *ngFor="let item of infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].iu_arqt_fichaarqtdetfiliacionculturals">
          
          <div class="badge mx-1"
            [ngClass]="{'badge-danger': item.ficha_filiacioncultural.nombre=='R',
                              'badge-warning': item.ficha_filiacioncultural.nombre=='C',
                              'badge-primary':item.ficha_filiacioncultural.nombre=='CP',
                              'badge-success': item.ficha_filiacioncultural.nombre=='PH'}">
            {{item.ficha_filiacioncultural.nombre}}
          </div>
          <div class="text_desc_mini">{{item.ficha_filiacioncultural.descripcion}}</div>
        </div>
        
        </div>
      </div>
    </div>
    <!--************************************************-->
    <div class="col-md-6">
      <div class="row">
        <div class="col-md-12 border border-top-0 bg-warning">
          CONTEXTO HISTORICO ESPACIAL
        </div>
        <div class="col-md-12">
          {{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].contexto_historico_espacial}}
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 border border-top-0 bg-warning">
          DESCRIPCION GENERAL
        </div>
        <div class="col-md-12">
          {{infoFichaCatalogacion.iu_arqt_fichaarquitectonicas[0].descripcion_general}} 
        </div>
      </div>
    </div>
  </div>
  <div class="row text-white">
    <div class="col-md-12 col-sm-6">
      <p [innerHtml]="infoFichaCatalogacion.direccion"></p>
      
    </div>
  </div>
</div>

<div *ngIf="infoFichaResumen" id="info_resumen_ficha"> 
  <h1>{{infoFichaResumen.ficha_fichaseguimientos[0].arquitectonica}}</h1>

</div>
